<button
  [type]="btnType"
  [ngClass]="btnClass"
  class="text-center py-1 px-4 text-base w-full md:w-auto"
  [attr.aria-disabled]="disabled ? true : null"
  [attr.aria-label]="ariaLabel || null"
  (click)="handleClick($event)">
  <ng-content></ng-content>
</button>
